/* Performance Reel | Orange button shadows. Pure visual decoration; no click handling. */
(function(){
  "use strict";
  if(window.__prOrangeButtonShadowInstalled)return;
  window.__prOrangeButtonShadowInstalled=true;

  var selector='button, input[type="submit"], input[type="button"], a.btn, a[class*="btn"], a[class*="button"], a[class*="cta"], [role="button"]';
  function isOrange(background){
    var color=/^rgba?\(\s*(\d+)[,\s]+(\d+)[,\s]+(\d+)/i.exec(background||'');
    if(!color)return false;
    var r=Number(color[1]),g=Number(color[2]),b=Number(color[3]);
    return r>=235&&g>=65&&g<=125&&b<=50;
  }
  function decorate(element){
    if(!element||!element.isConnected||element.classList.contains('pr-promo2__cta'))return;
    var orange=isOrange(window.getComputedStyle(element).backgroundColor);
    element.classList.toggle('pr-orange-button-shadow',orange);
  }
  function scan(root){
    if(!root||root.nodeType!==1)return;
    if(root.matches(selector))decorate(root);
    root.querySelectorAll(selector).forEach(decorate);
  }
  function init(){
    scan(document.body);
    var pending=new Set();
    var scheduled=false;
    function flush(){
      scheduled=false;
      pending.forEach(scan);
      pending.clear();
    }
    var observer=new MutationObserver(function(records){
      for(var i=0;i<records.length;i++){
        var nodes=records[i].addedNodes;
        for(var j=0;j<nodes.length;j++){
          if(nodes[j].nodeType===1)pending.add(nodes[j]);
        }
      }
      if(pending.size&&!scheduled){
        scheduled=true;
        window.requestAnimationFrame(flush);
      }
    });
    observer.observe(document.body,{subtree:true,childList:true});
    document.addEventListener('shopify:section:load',function(event){scan(event.target)});
    window.addEventListener('load',function(){scan(document.body)},{once:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
